import { Fragment, useContext } from 'react';
import CarouselHome from '../../components/carousel/carousel.component'

import { DropdownContext } from '../../context/dropdown.context';
import HeaderDropdown from '../../components/header-dropdown/header-dropdown.component';

import { BannerContainer, BannerText, CarouselContainer } from './home.styles.jsx'
import './home.styles.scss';

const Home = () => {
  const { isDropdownOpen } = useContext(DropdownContext)

  return (
    <Fragment>
      {isDropdownOpen && <HeaderDropdown />}
      <div className='banner-container'>
        <BannerText>
          <p style={{fontSize: '50px'}}>PASION</p>
          <p>por iniciar, desarrollar y concretar proyectos inmobiliarios</p>
        </BannerText>
      </div>
      <CarouselContainer>
        <CarouselHome />
      </CarouselContainer>
    </Fragment>
  )
}

export default Home;